import React from "react";
import { CCol, CFormGroup, CInput, CLabel, CRow } from "@coreui/react";
import { useAutoInvoiceFormContext } from "../context/AutoInvoiceFormContext";
import { FieldErrors } from "../../form/FieldErrors";
import { getFieldErrors } from "../../../models/errors";

const SectionDivider: React.FC<{ icon: string; label: string }> = ({ icon, label }) => (
  <div style={{ display: "flex", alignItems: "center", marginBottom: "16px", marginTop: "16px" }}>
    <div style={{ width: "4px", height: "18px", background: "#006657", borderRadius: "2px", marginRight: "10px", flexShrink: 0 }} />
    <i className={`fa ${icon} mr-2`} style={{ fontSize: "0.85rem", color: "var(--theme-accent)" }}></i>
    <h6 style={{ margin: 0, fontWeight: 600, color: "var(--theme-muted)", fontSize: "0.78rem", textTransform: "uppercase", letterSpacing: "0.8px" }}>
      {label}
    </h6>
    <div style={{ flex: 1, height: "1px", background: "var(--theme-divider)", marginLeft: "10px" }} />
  </div>
);

const FormLabel: React.FC<{ required?: boolean; children: React.ReactNode }> = ({ required, children }) => (
  <CLabel className="mb-0" style={{ fontWeight: 600, fontSize: "0.875rem", color: "var(--theme-text-soft)" }}>
    {required && <span className="text-danger mr-1">*</span>}
    {children}
  </CLabel>
);

const AutoInvoiceFormCertificateSection: React.FC = () => {
  const {
    autoInvoiceRef,
    errors,
    onCertificateNumberChange,
    onCertificateCodeChange,
  } = useAutoInvoiceFormContext();

  return (
    <>
      <SectionDivider icon="fa-certificate" label="Constancia de No Contribuyente (DNIT)" />
      <CFormGroup>
        <CRow className="align-items-center">
          <CCol md={2}>
            <FormLabel required>Nro. Constancia:</FormLabel>
          </CCol>
          <CCol md={2}>
            <CInput
              type="text"
              defaultValue={
                autoInvoiceRef.current
                  ? autoInvoiceRef.current.certificateNumber
                  : undefined
              }
              onChange={onCertificateNumberChange}
              placeholder="Nro. Constancia no Contribuyente"
            />
            <FieldErrors
              errors={getFieldErrors("certificateNumber", errors) as string[]}
            />
          </CCol>
          <CCol md={2}>
            <FormLabel required>Código Constancia:</FormLabel>
          </CCol>
          <CCol md={2}>
            <CInput
              type="text"
              defaultValue={
                autoInvoiceRef.current
                  ? autoInvoiceRef.current.certificateCode
                  : undefined
              }
              onChange={onCertificateCodeChange}
              placeholder="Código Constancia No Contribuyente"
            />
            <FieldErrors
              errors={getFieldErrors("certificateCode", errors) as string[]}
            />
          </CCol>
        </CRow>
      </CFormGroup>
    </>
  );
};

export default AutoInvoiceFormCertificateSection;
